import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';
import { buildQueryParams } from '../../utils/object';

export const practiceCalendarApi = createApi({
  reducerPath: 'practiceCalendarApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['PracticeCalendar'],
  endpoints: (builder) => ({
    getPracticeCalendar: builder.query({
      query: ({ crop_id, page, limit, search } = {}) => ({
        url: 'practice-calendar',
        params: buildQueryParams({ crop_id, page, limit, search }),
      }),
      providesTags: ['PracticeCalendar'],
    }),

    createPracticeCalendar: builder.mutation({
      query: (newEntry) => ({
        url: 'practice-calendar',
        method: 'POST',
        body: newEntry,
      }),
      invalidatesTags: ['PracticeCalendar'],
    }),

    updatePracticeCalendar: builder.mutation({
      query: ({ id, updatedEntry }) => ({
        url: `practice-calendar/${id}`,
        method: 'PUT',
        body: updatedEntry,
      }),
      invalidatesTags: ['PracticeCalendar'],
    }),

    deletePracticeCalendar: builder.mutation({
      query: (id) => ({
        url: `practice-calendar/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PracticeCalendar'],
    }),

    uploadPracticeCalendarCSV: builder.mutation({
      query: ({ cropId, formData }) => ({
        url: `practice-calendar/${cropId}/upload-csv`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['PracticeCalendar'],
    }),
  }),
});

export const {
  useGetPracticeCalendarQuery,
  useLazyGetPracticeCalendarQuery,
  useCreatePracticeCalendarMutation,
  useUpdatePracticeCalendarMutation,
  useDeletePracticeCalendarMutation,
  useUploadPracticeCalendarCSVMutation,
} = practiceCalendarApi;
